import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IGroup } from '@interfaces/IGroup';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  constructor(private _http: HttpClient) {}

  getGroups(courseId?: number): Observable<IGroup[]> {
    let url = `${environment.baseUrl}api/v1/groups/`;
    if (courseId) {
      url += `?course_id=${courseId}`;
    }
    return this._http.get<IGroup[]>(url);
  }

  getGroup(id: number): Observable<IGroup> {
    const url = `${environment.baseUrl}api/v1/groups/${id}/`;
    return this._http.get<IGroup>(url);
  }

  setStudentOnline(data: {
    group_id: number;
    student_id: number;
  }): Observable<{ detail: string }> {
    const url = `${environment.baseUrl}api/v1/groups/${data.group_id}/students/${data.student_id}/change-format/`;
    return this._http.patch<{ detail: string }>(url, null);
  }
}
